import React from "react";
import { TokenManager } from "../helpers/api_helper";

const Navdata = () => {
    const menuItems: any = [
        {
            label: "Admin",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Overview",
            icon: "ri-dashboard-2-line",
            link: "/dashboard",
        },
        {
            id: "properties",
            label: "Properties",
            icon: "ri-building-line",
            link: "/properties",
        },
        {
            id: "property-access",
            label: "Property Access",
            icon: "ri-shield-user-line",
            link: "/property-access",
        },
        {
            id: "vendors",
            label: "Vendors",
            icon: "ri-store-2-line",
            link: "/vendors",
        },
        {
            id: "vendor-groups",
            label: "Vendor Groups",
            icon: "ri-group-line",
            link: "/vendor-groups",
        },
        {
            id: "bookings",
            label: "Bookings",
            icon: "ri-calendar-check-line",
            link: "/bookings",
        },
        {
            id: "reports",
            label: "Reports",
            icon: "ri-file-chart-line",
            link: "/reports",
        },
    ];

    if (TokenManager.isSuperAdmin()) {
        menuItems.push({
            id: "promotions",
            label: "Promotions",
            icon: "ri-coupon-3-line",
            link: "/promotions",
        });
    }

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
